import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz'
import _ from 'lodash'

export const convertToTargetTimeZone = (date, originalTimeZone) => {
  // Get users time zone
  const targetTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  // Check if originalTimeZone is valid
  if (!originalTimeZone || typeof originalTimeZone !== 'string') {
    return { error: 'Invalid time zone' }
  }

  try {
    // Convert the given date to UTC based on the original timezone,
    // and then convert it to PST time
    const utcDate = zonedTimeToUtc(date, originalTimeZone)
    const targetDate = utcToZonedTime(utcDate, targetTimeZone)

    const timeZoneAbbreviation = new Intl.DateTimeFormat('en-US', {
      timeZone: targetTimeZone,
      timeZoneName: 'short'
    })
      .format(targetDate)
      .split(' ')[1]

    return { targetDate, timeZoneAbbreviation }
  } catch {
    return { error: 'Error converting time zone' }
  }
}

export const parseAndShiftDateUTC = dateString => {
  const [month, day, year] = _.split(dateString, '-').map(Number)
  return Date.UTC(year, month - 1, day + 1) // Note: In relation to the sensitive date story, since the date itself should be excluded, thereby it is【day + 1】
}
